module.exports = __webpack_public_path__ + "static/media/CR.26d14f4d.png";